import React, { useContext, useState } from "react";
import { useCookies } from "react-cookie";
import { SiteContext } from "./site-context";

import * as styles from "./gdpr.module.css";

// cookie name must match gatsby-config.js and layout.js
export const GDPR_COOKIE = "gdpr-agree";

const COOKIE_OPTIONS = { path: "/", maxAge: 365 * 24 * 60 * 60 };

export const Gdpr = () => {
  const site = useContext(SiteContext);
  const [showPreferences, setShowPreferences] = useState(false);
  const [preferenceChoice, setPreferenceChoice] = useState("standard");

  const cookieName =
    site.isLiveProd || site.isActive("allowTrack")
      ? GDPR_COOKIE
      : "faux-gdpr-cookie";

  const [cookies, setCookie] = useCookies([cookieName]);
  const hasConsented = !!cookies[cookieName];

  if (hasConsented) return null;

  const handleDecline = () => {
    setCookie(cookieName, "declined", COOKIE_OPTIONS);
    site.setTrackingLevel("declined");
  };

  const handleAccept = () => {
    setCookie(cookieName, "true", COOKIE_OPTIONS);
    site.setTrackingLevel("standard");
  };

  const handleOk = () => {
    if (showPreferences) {
      if (preferenceChoice === "essentials") {
        setCookie(cookieName, "essentials", COOKIE_OPTIONS);
        site.setTrackingLevel("essentials");
      } else if (preferenceChoice === "declined") {
        setCookie(cookieName, "declined", COOKIE_OPTIONS);
        site.setTrackingLevel("declined");
      } else {
        handleAccept();
      }
    } else {
      handleAccept();
    }
  };

  return (
    <div
      className={`CookieConsent ${styles.banner}`}
      style={{ padding: showPreferences ? "1rem 1rem 1.25rem" : "1rem" }}
    >
      <div className={styles.content}>
        <span className="inline sm:hidden pr-2">
          We use tracking to better understand our visitors.{" "}
          <a href="/privacy-policy/" target="_blank" className="text-sm">
            Read more.
          </a>
        </span>
        <span className="hidden sm:inline pr-4 text-md">
          We use cookies and similar technologies to better understand our visitors and personalize your experience.{" "}
          <a href="/privacy-policy/" target="_blank" className="text-sm">
            Read more.
          </a>
        </span>

        {showPreferences && (
          <div className={styles.preferences}>
            <span className={styles.preferencesLabel}>Tracking Preferences:</span>
            <label className={styles.preferenceOption}>
              <input
                type="radio"
                name="trackingLevel"
                value="standard"
                checked={preferenceChoice === "standard"}
                onChange={() => setPreferenceChoice("standard")}
              />
              Standard
            </label>
            <label className={styles.preferenceOption}>
              <input
                type="radio"
                name="trackingLevel"
                value="essentials"
                checked={preferenceChoice === "essentials"}
                onChange={() => setPreferenceChoice("essentials")}
              />
              Essentials
            </label>
            <label className={styles.preferenceOption}>
              <input
                type="radio"
                name="trackingLevel"
                value="declined"
                checked={preferenceChoice === "declined"}
                onChange={() => setPreferenceChoice("declined")}
              />
              None
            </label>
          </div>
        )}
      </div>

      <div className={styles.buttons}>
        <button
          className={styles.declineButton}
          style={{ fontWeight: "500", borderRadius: "0.5rem", padding: "0.5rem 1rem" }}
          onClick={handleDecline}
        >
          Decline
        </button>
        <button
          className={`${styles.preferencesButton}${showPreferences ? ` ${styles.preferencesButtonActive}` : ""}`}
          style={{ fontWeight: "500", borderRadius: "0.5rem", padding: "0.5rem 1rem" }}
          onClick={() => setShowPreferences((v) => !v)}
        >
          Preferences
        </button>
        <button
          className={styles.button}
          style={{ fontWeight: "500", borderRadius: "0.5rem", padding: "0.5rem 1rem" }}
          onClick={handleOk}
        >
          OK
        </button>
      </div>
    </div>
  );
};
